// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__0XleF","buttons":"Profile_buttons__+gfEm"};